import { supabase } from '../lib/supabase';
import { AudioSyncService } from './recording/AudioSyncService';
import { Recording } from './RecordingService';

export class SyncCalculationService {
  static async calculateAndSaveSyncOffset(recording: Recording): Promise<number | null> {
    try {
      if (!recording.song?.audio_url) {
        console.warn('No backing track available for sync calculation');
        return null;
      }

      console.log(`Calculating sync offset for recording ${recording.id}...`);

      const recordingResponse = await fetch(recording.recording_url);
      if (!recordingResponse.ok) {
        throw new Error('Failed to fetch recording');
      }
      const recordingBlob = await recordingResponse.blob();

      const backingTrackResponse = await fetch(recording.song.audio_url);
      if (!backingTrackResponse.ok) {
        throw new Error('Failed to fetch backing track');
      }
      const backingTrackBlob = await backingTrackResponse.blob();

      const offset = await AudioSyncService.detectTimingOffset(
        recordingBlob,
        backingTrackBlob,
        15
      );

      console.log(`Sync offset calculated: ${offset.toFixed(3)} seconds`);

      const { error } = await supabase
        .from('recordings')
        .update({ audio_sync_offset: offset })
        .eq('id', recording.id);

      if (error) {
        console.error('Failed to save sync offset:', error);
        throw error;
      }

      return offset;
    } catch (error) {
      console.error('Error calculating sync offset:', error);
      throw error;
    }
  }

  static async batchCalculateSyncOffsets(recordings: Recording[]): Promise<void> {
    const recordingsToProcess = recordings.filter(
      r => r.audio_sync_offset === null && r.song?.audio_url
    );

    console.log(`Processing ${recordingsToProcess.length} recordings...`);

    for (const recording of recordingsToProcess) {
      try {
        await this.calculateAndSaveSyncOffset(recording);
      } catch (error) {
        console.error(`Failed to process recording ${recording.id}:`, error);
      }
    }

    console.log('Batch processing complete');
  }
}
